module.exports = __webpack_public_path__ + "img/card-header_orginazition.57062d72.png";